// extracted by mini-css-extract-plugin
export default {"container":"ContextMenu_container__Ae7yb","action":"ContextMenu_action__-Um9n","actionName":"ContextMenu_actionName__1Lagx"};